import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { ARTSY_NAV_LINKS as NAV_LINKS, PROFILE } from "../data/content";

const EASE = [0.76, 0, 0.24, 1];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  return (
    <>
      <header
        className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-5 md:px-10 h-20 bg-sand/80 backdrop-blur-md border-b border-ink/10"
        data-testid="site-header"
      >
        <Link
          to="/"
          className="font-serif text-2xl md:text-3xl tracking-tight text-ink"
          data-testid="nav-logo"
        >
          {PROFILE.name}
          <span className="text-terracotta">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className={`draw-link text-sm uppercase tracking-widest ${
                location.pathname === link.path ? "text-terracotta" : "text-ink"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button
          className="md:hidden text-ink"
          onClick={() => setOpen(true)}
          data-testid="nav-menu-open"
          aria-label="Open menu"
        >
          <Menu size={28} />
        </button>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            className="fixed inset-0 z-[60] bg-ink text-sand flex flex-col"
            initial={{ clipPath: "inset(0 0 100% 0)" }}
            animate={{ clipPath: "inset(0 0 0% 0)" }}
            exit={{ clipPath: "inset(0 0 100% 0)" }}
            transition={{ duration: 0.6, ease: EASE }}
            data-testid="mobile-menu"
          >
            <div className="flex items-center justify-between px-5 h-20">
              <span className="font-serif text-2xl text-sand">{PROFILE.name}.</span>
              <button
                onClick={() => setOpen(false)}
                data-testid="nav-menu-close"
                aria-label="Close menu"
              >
                <X size={30} />
              </button>
            </div>
            <nav className="flex flex-col justify-center flex-1 px-8 gap-2">
              {NAV_LINKS.map((link, i) => (
                <motion.div
                  key={link.path}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.15 + i * 0.06, ease: EASE }}
                >
                  <Link
                    to={link.path}
                    className="font-serif text-5xl font-light text-sand"
                    data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                  >
                    {link.label}
                  </Link>
                </motion.div>
              ))}
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
